import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    some: "messagge",
    homePageChunkID: 26,
    chunks: [
      {
        id: 29,
        video: 2,
        title: 'Linear search demonstration on stage',
        start: 245,
        end: 376
      },
      {
        id: 30,
        video: 2,
        title: 'Binary search demonstration on stage',
        start: 379,
        end: 477
      },
      {
        id: 31,
        video: 2,
        title: 'Big O notation',
        start: 718,
        end: 903
      },
      {
        id: 32,
        video: 2,
        title: 'Omega (Ω) notation',
        start: 903,
        end: 1119
      },
      {
        id: 3,
        video: 2,
        title: 'Custom types in C',
        start: 1915,
        end: 2253
      },
      {
        id: 4,
        video: 3,
        title: "Apex",
        start: 35,
        end: 40
      },
      {
        id: 6,
        video: 4,
        title: "Difference between \"var\" and \"let\" keywords",
        start: 74,
        end: 234
      },
      {
        id: 7,
        video: 4,
        title: "Difference between double (==) and tripple (===) equality expression",
        start: 234,
        end: 363
      },
      {
        id: 8,
        video: 4,
        title: "Difference between \"let\" and \"const\" keywords",
        start: 363,
        end: 547
      },
      {
        id: 9,
        video: 4,
        title: "Difference between \"undefined\" and \"null\" keywords",
        start: 547,
        end: 602
      },
      {
        id: 10,
        video: 4,
        title: "Use of Arrow function",
        start: 602,
        end: 706
      },
      {
        id: 11,
        video: 5,
        title: "What is prototypal inheritance",
        start: 28,
        end: 177
      },
      {
        id: 12,
        video: 5,
        title: "Difference between function declaration and function expression",
        start: 178,
        end: 262
      },
      {
        id: 13,
        video: 5,
        title: "What is promises and why do we use it",
        start: 262,
        end: 402
      },
      {
        id: 14,
        video: 5,
        title: "Question about setTimeout()",
        start: 402,
        end: 502
      },
      {
        id: 15,
        video: 5,
        title: "What is closure and how do you use it",
        start: 502,
        end: 658
      },
      {
        id: 19,
        video: 8,
        title: "Another moment of truth",
        start: 300,
        end: 0
      },
      {
        id: 20,
        video: 9,
        title: "You are breathtaking",
        start: 139,
        end: 144
      },
      {
        id: 26,
        video: 9,
        title: "Do you guys wanna know when the release date?",
        start: 151,
        end: 159
      },
      {
        id: 27,
        video: 9,
        title: "Check this out!",
        start: 162,
        end: 164
      },
      {
        id: 28,
        video: 10,
        title: "Rule of thumb (literally) for steak doneness",
        start: 396,
        end: 435
      },
      {
        id: 33,
        video: 11,
        title: "From countdown and liftoff to central core landing",
        start: 1310,
        end: 1853
      },
      {
        id: 34,
        video: 11,
        title: "Boosters landing",
        start: 1788,
        end: 1853
      },
      {
        id: 35,
        video: 12,
        title: "Mask on",
        start: 83,
        end: 88
      },
      {
        id: 36,
        video: 13,
        title: "Dice stacking",
        start: 94,
        end: 159
      },
      {
        id: 37,
        video: 13,
        title: "Dotted lines on chalkboard",
        start: 196,
        end: 240
      },
      {
        id: 38,
        video: 13,
        title: "The tablecloth trick",
        start: 270,
        end: 308
      },
      {
        id: 39,
        video: 13,
        title: "Spinning stuff",
        start: 330,
        end: 361
      },
      {
        id: 40,
        video: 13,
        title: "Sabering champagne",
        start: 382,
        end: 467
      },
      {
        id: 41,
        video: 13,
        title: "Card spring",
        start: 496,
        end: 541
      },
      {
        id: 42,
        video: 13,
        title: "Breaking a wine glass with voice",
        start: 577,
        end: 722
      },
      {
        id: 43,
        video: 14,
        title: "1: Learn from professional",
        start: 46,
        end: 219
      },
      {
        id: 44,
        video: 14,
        title: "2: Never freedive alone",
        start: 219,
        end: 347
      },
      {
        id: 45,
        video: 14,
        title: "3: Be sure you freediving buddy can provide safety",
        start: 347,
        end: 443
      },
      {
        id: 46,
        video: 14,
        title: "4: Have big bright red or yellow surface marker",
        start: 443,
        end: 540
      },
      {
        id: 47,
        video: 14,
        title: "5: Don't be overweighted",
        start: 541,
        end: 599
      },
      {
        id: 48,
        video: 14,
        title: "6: One up, One down",
        start: 599,
        end: 660
      },
      {
        id: 49,
        video: 15,
        title: "Original video",
        start: 195,
        end: 227
      },
      {
        id: 50,
        video: 15,
        title: "Upload #10",
        start: 365,
        end: 418
      },
      {
        id: 51,
        video: 15,
        title: "Upload #50",
        start: 485,
        end: 540
      },
      {
        id: 55,
        video: 15,
        title: "Upload #500",
        start: 655,
        end: 706
      },
      {
        id: 56,
        video: 15,
        title: "Upload #1000",
        start: 708,
        end: 769
      },
      {
        id: 57,
        video: 15,
        title: "Sequence of all uploads",
        start: 786,
        end: 815
      },
      {
        id: 58,
        video: 16,
        title: "Status bar",
        start: 12,
        end: 58
      },
      {
        id: 59,
        video: 16,
        title: "Scale panels",
        start: 58,
        end: 68
      },
      {
        id: 60,
        video: 16,
        title: "Changing panels",
        start: 68,
        end: 77
      },
      {
        id: 61,
        video: 16,
        title: "Adding/spliting panels",
        start: 77,
        end: 86
      },
      {
        id: 62,
        video: 16,
        title: "Deleting panel",
        start: 86,
        end: 93
      },
      {
        id: 63,
        video: 16,
        title: "Maximize panel",
        start: 93,
        end: 105
      },
      {
        id: 64,
        video: 16,
        title: "Default workspaces",
        start: 105,
        end: 154
      },
      {
        id: 65,
        video: 16,
        title: "Tools quick menu (T)",
        start: 154,
        end: 188
      },
      {
        id: 66,
        video: 16,
        title: "Sidebar with quick settings (N)",
        start: 188,
        end: 201
      },
      {
        id: 67,
        video: 16,
        title: "3D cursor",
        start: 201,
        end: 235
      },
      {
        id: 68,
        video: 16,
        title: "Pie menus",
        start: 235,
        end: 280
      },
      {
        id: 69,
        video: 16,
        title: "Timeline",
        start: 280,
        end: 308
      },
      {
        id: 70,
        video: 16,
        title: "Options of current tool",
        start: 308,
        end: 318
      },
      {
        id: 71,
        video: 16,
        title: "Scene specific options",
        start: 318,
        end: 337
      },
      {
        id: 72,
        video: 16,
        title: "Render tab",
        start: 337,
        end: 351
      },
      {
        id: 73,
        video: 16,
        title: "Output tab",
        start: 351,
        end: 364
      },
      {
        id: 74,
        video: 16,
        title: "View layer tab",
        start: 364,
        end: 397
      },
      {
        id: 75,
        video: 16,
        title: "Outliner",
        start: 397,
        end: 416
      },
      {
        id: 76,
        video: 16,
        title: "General scene tab",
        start: 416,
        end: 425
      },
      {
        id: 77,
        video: 16,
        title: "Global tab",
        start: 425,
        end: 446
      },
      {
        id: 78,
        video: 16,
        title: "Active object tabs",
        start: 446,
        end: 455
      },
      {
        id: 79,
        video: 16,
        title: "Object tab",
        start: 455,
        end: 469
      },
      {
        id: 80,
        video: 16,
        title: "Modifiers tab",
        start: 469,
        end: 495
      },
      {
        id: 81,
        video: 16,
        title: "Particles tab",
        start: 495,
        end: 507
      },
      {
        id: 82,
        video: 16,
        title: "Physics tab",
        start: 507,
        end: 522
      },
      {
        id: 83,
        video: 16,
        title: "Constraints tab",
        start: 522,
        end: 551
      },
      {
        id: 84,
        video: 16,
        title: "Mesh data",
        start: 551,
        end: 583
      },
      {
        id: 85,
        video: 16,
        title: "Material tab",
        start: 583,
        end: 601
      },
      {
        id: 86,
        video: 16,
        title: "Texture tab",
        start: 601,
        end: 625
      },
      {
        id: 87,
        video: 16,
        title: "Lamp object",
        start: 625,
        end: 646
      },
      {
        id: 88,
        video: 16,
        title: "Camera object",
        start: 646,
        end: 660
      },

      {
        id: 89,
        video: 1,
        title: 'What is Vue',
        start: 56,
        end: 0
      },
      {
        id: 90,
        video: 1,
        title: 'Why use Vue',
        start: 76,
        end: 0
      },
      {
        id: 91,
        video: 1,
        title: 'What you should know before learning Vue',
        start: 155,
        end: 0
      },
      {
        id: 92,
        video: 1,
        title: 'Reusable components. Todo App plan',
        start: 190,
        end: 0
      },
      {
        id: 93,
        video: 1,
        title: 'Anatomy of a component',
        start: 278,
        end: 0
      },
      {
        id: 94,
        video: 1,
        title: 'Vue CLI (command line interface)',
        start: 342,
        end: 0
      },
      {
        id: 95,
        video: 1,
        title: 'Vuex for state management',
        start: 396,
        end: 0
      },
      {
        id: 96,
        video: 1,
        title: 'Installing Vue',
        start: 434,
        end: 0
      },
      {
        id: 97,
        video: 1,
        title: 'Creating application (CLI way)',
        start: 525,
        end: 0
      },
      {
        id: 98,
        video: 1,
        title: 'Creating application (GUI way)',
        start: 634,
        end: 0
      },
      {
        id: 99,
        video: 1,
        title: 'Default project structure and code overview',
        start: 778,
        end: 0
      },
      {
        id: 100,
        video: 1,
        title: 'Data',
        start: 1167,
        end: 0
      },
      {
        id: 101,
        video: 1,
        title: 'Todo component',
        start: 1291,
        end: 0
      },
      {
        id: 102,
        video: 17,
        title: 'Overview and plan',
        start: 7,
        end: 86
      },
      {
        id: 103,
        video: 17,
        title: 'Vorbereitung (Preparation)',
        start: 86,
        end: 169
      },
      {
        id: 104,
        video: 17,
        title: 'Haustür ausbauen (Remove the front door)',
        start: 169,
        end: 289
      },
      {
        id: 105,
        video: 17,
        title: 'Haustür einbauen (Install the front door)',
        start: 289,
        end: 1265
      },
      {
        id: 106,
        video: 17,
        title: 'Abschlussarbeiten (Finishing)',
        start: 1265,
        end: 1438
      },
      {
        id: 107,
        video: 18,
        title: 'Intro',
        start: 5,
        end: 42
      },
      {
        id: 108,
        video: 18,
        title: 'Honeywell Germ Free Cool Mist Humidifier',
        start: 42,
        end: 77
      },
      {
        id: 109,
        video: 18,
        title: 'Holmes® Ultrasonic Cool Mist Humidifier',
        start: 77,
        end: 107
      },
      {
        id: 110,
        video: 18,
        title: 'Honeywell Warm Mist Humidifier',
        start: 107,
        end: 146
      },
      {
        id: 111,
        video: 18,
        title: '5.4 Gallon Oak-Finish Cool Mist Humidifier',
        start: 146,
        end: 184
      },
      {
        id: 112,
        video: 18,
        title: 'General recommendations',
        start: 184,
        end: 213
      },
      {
        id: 113,
        video: 19,
        title: 'Intro',
        start: 0,
        end: 23
      },
      {
        id: 114,
        video: 19,
        title: 'Oil Paint',
        start: 23,
        end: 371
      },
      {
        id: 115,
        video: 19,
        title: 'Birkin Bags',
        start: 371,
        end: 867
      },
      {
        id: 116,
        video: 19,
        title: 'Pedigree Dogs',
        start: 867,
        end: 1236
      },
      {
        id: 117,
        video: 19,
        title: 'Pink Himalayan Salt',
        start: 1236,
        end: 1529
      },
      {
        id: 118,
        video: 19,
        title: 'Tiger Fugu',
        start: 1529,
        end: 1874
      },
      {
        id: 119,
        video: 19,
        title: 'Japanese Melons',
        start: 1874,
        end: 2295
      },
      {
        id: 120,
        video: 19,
        title: 'Bonsai',
        start: 2295,
        end: 2646
      },
      {
        id: 121,
        video: 19,
        title: 'Manuka Honey',
        start: 2646,
        end: 3022
      },
      {
        id: 122,
        video: 19,
        title: 'Racing Pigeons',
        start: 3022,
        end: 3381
      },
      {
        id: 123,
        video: 19,
        title: 'Lobsters',
        start: 3381,
        end: 3804
      },
      {
        id: 124,
        video: 19,
        title: 'Supreme',
        start: 3804,
        end: 4241
      },
      {
        id: 125,
        video: 19,
        title: 'Wagyu Beef',
        start: 4241,
        end: 4630
      },
      {
        id: 126,
        video: 19,
        title: 'Air Jordans',
        start: 4630,
        end: 5099
      },
      {
        id: 127,
        video: 19,
        title: 'Printer Ink',
        start: 5099,
        end: 5375
      },
      {
        id: 128,
        video: 2,
        title: 'Sorting',
        start: 2241,
        end: 5337
      },
      {
        id: 129,
        video: 2,
        title: 'Bubble sorting',
        start: 2310,
        end: 2890
      },
      {
        id: 130,
        video: 2,
        title: 'Selection sorting',
        start: 2890,
        end: 3405
      },
      {
        id: 131,
        video: 2,
        title: 'Optimising sorting algorithms',
        start: 3405,
        end: 3716
      },
      {
        id: 132,
        video: 2,
        title: 'Recursion',
        start: 3794,
        end: 4630
      },
      {
        id: 133,
        video: 2,
        title: 'Merge sort',
        start: 4630,
        end: 5224
      },
      {
        id: 134,
        video: 2,
        title: 'Visual comparison of sorting algorithms',
        start: 5224,
        end: 5337
      },

      {
        id: 135,
        video: 20,
        title: 'From countdown to landing',
        start: 678,
        end: 1213
      },
      {
        id: 136,
        video: 20,
        title: 'Catching a fairing',
        start: 3090,
        end: 3259
      },
      {
        id: 137,
        video: 20,
        title: 'Deployment of satellites',
        start: 4442,
        end: 4513
      },

      {
        id: 138,
        video: 21,
        title: 'Fuel centrifuge demonstration',
        start: 2017,
        end: 2073
      },


      {
        id: 139,
        video: 22,
        title: 'Vampire’s Kiss',
        start: 9,
        end: 30.5
      },
      {
        id: 140,
        video: 22,
        title: 'Ghost Rider',
        start: 30.8,
        end: 31.3
      },
      {
        id: 141,
        video: 22,
        title: 'Vampire’s Kiss',
        start: 32,
        end: 49
      },
      {
        id: 142,
        video: 22,
        title: 'Deadfall',
        start: 50,
        end: 71
      },
      {
        id: 143,
        video: 22,
        title: 'Vampire’s Kiss',
        start: 71.5,
        end: 78.5
      },
      {
        id: 144,
        video: 22,
        title: 'Deadfall, Face/Off, Red Rock West, Deadfall',
        start: 80,
        end: 95
      },
      {
        id: 145,
        video: 22,
        title: 'The Bad Lieutenant: Port of Call',
        start: 95.5,
        end: 103
      },
      {
        id: 146,
        video: 22,
        title: 'Matchstick Men',
        start: 103.5,
        end: 107
      },
      {
        id: 147,
        video: 22,
        title: 'Leaving Las Vegas',
        start: 107.5,
        end: 112
      },
      {
        id: 148,
        video: 22,
        title: 'Vampire’s Kiss',
        start: 112.5,
        end: 115
      },
      {
        id: 149,
        video: 22,
        title: 'Bringing Out the Dead, Face/Off, 8mm, Adaptation, Wild at Heart',
        start: 115.5,
        end: 123.5
      },
      {
        id: 150,
        video: 22,
        title: 'Windtalkers, Raising Arizona, Bringing Out the Dead, The Wicker Man',
        start: 123.5,
        end: 137
      },
      {
        id: 151,
        video: 22,
        title: 'Vampire’s Kiss',
        start: 137.5,
        end: 140.5
      },
      {
        id: 152,
        video: 22,
        title: 'Deadfall',
        start: 141.5,
        end: 154.5
      },
      {
        id: 153,
        video: 22,
        title: 'The Wicker Man',
        start: 155.5,
        end: 190
      },
      {
        id: 154,
        video: 22,
        title: 'Deadfall',
        start: 190.5,
        end: 199
      },
      {
        id: 155,
        video: 22,
        title: 'The Wicker Man',
        start: 200,
        end: 217
      },
      {
        id: 156,
        video: 22,
        title: 'Ghost Rider',
        start: 217,
        end: 223
      },
      {
        id: 157,
        video: 22,
        title: 'Zandalee',
        start: 223,
        end: 250
      },
    ],
    videos: [
      {id: 17, key: 'jIJTqiXDdQk', title: "Haustür tauschen | HORNBACH Meisterschmiede (Change front door)", duration: 1462},
      {id: 1, key: 'Wy9q22isx3U', title: "Vue.js Crash Course", duration: 4132},
      {id: 18, key: '7VMUBDXkZUg', title: "Which Humidifier is Right for Your Home?", duration: 217},
      {id: 2, key: 'fykrlqbV9wM', title: "CS500: Algorithms", duration: 5339},
      {id: 11, key: 'wbSwFU6tY1c', title: "Falcon Heavy Test Flight", duration: 2058},
      {id: 19, key: 'rWrdN7_2TcU', title: "So Expensive Season 3 Marathon", duration: 5390},
      {id: 4, key: 'oxoFVqetl1E', title: "Top 10 JavaScript Interview Questions", duration: 731},
      // {id: 5, key: 'yo3MJPcVJc8', title: "Top 10 JavaScript Interview Questions ( Part 2 )", duration: 785},
      {id: 9, key: '0DWap7pS7XM', title: "KEANU REEVES says \"You're breathtaking\" (E3 2019, Cyberpunk 2077)", duration: 223},
      {id: 10, key: 'pkPFyxnhT7A', title: "Cooking Sirloin Steak with Sandy Crombie", duration: 744},
      {id: 12, key: 'IEFhC1h3LY8', title: "Gulfstream G-IV Oxygen Mask - Pilot VLOG 107", duration: 197},
      {id: 13, key: 'A4TkmLKztqI', title: "Things I Can Do In Slow Motion", duration: 758},
      {id: 14, key: 'YfhApPC-FQU', title: "5 Powerful Freediving Safety Rules. Open Water Session", duration: 687},
      {id: 15, key: 'JR4KHfqw-oE', title: "This Is What Happens When You Re-Upload a YouTube Video 1000 Times!", duration: 903},
      {id: 16, key: '8XyIYRW_2xk', title: "Interface Overview - Blender 2.80 Fundamentals", duration: 672},
      {id: 3, key: 'bYb3bfA6_sQ', title: "Starhopper's test flight", duration: 158},
      {id: 20, key: '1KmBDCiL7MU', title: "Starlink Mission", duration: 4513},
      {id: 21, key: '4jNz5hs3m7A', title: "Ferry Strip Down | Engineering Giants | Spark", duration: 3519},
      {id: 22, key: '4zySHepF04c', title: "Nicolas Cage Losing His Shit", duration: 253},

    ]
  },
  getters: {
    chunkByID: (state) => (id) => {
      return state.chunks.find(chunk => chunk.id == id)
    },
    isValidChunkByID: (state, getters) => (id) => {
      return getters.chunkByID(id) !== undefined
    },
    chunksAll: (state) => {
      return state.chunks;
    },
    chunksFromThisVideo: (state) => (goalVideoID) => {
      let chunks = state.chunks.filter(chunk => {
        return chunk.video == goalVideoID;
      })
      // TODO: change to more efficient way: Sorting with map
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
      let sortedChunks = chunks.sort((a,b) => a.start - b.start)
      return sortedChunks
    },
    chunksExceptThis: (state) => (goalChunk) => {
      return state.chunks.filter(chunk => {
        return chunk.id != goalChunk.id && chunk.video == goalChunk.video;
      })
    },
    chunksFromOtherVideos: (state) => (goalChunk) => {
      return state.chunks.filter(chunk => {
        return chunk.video != goalChunk.video;
      })
    },
    videosAll: (state) => {
      return state.videos
    },
    videoByID: (state) => (videoID) => {
      return state.videos.find(video => video.id == videoID)
    },
    videosExceptThis: (state) => (goalVideoID) => {
      return state.videos.filter(video => {
        return video.id != goalVideoID
      })
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
